import React from 'react';
import storyThumbnail from '../../../../assets/img/fundraiser-imgs/fr-img2.png'
const FundraisersStory = () => {
    return (
        <div >
            <section>
                <div className="row gy-4 mb-4">
                    <div className="col-12 col-lg-4">
                        <div className="card fundrisers-route-border-with-radius">
                            <div className="position-relative">
                                <img className="w-100 fundrisers-route-image-border-curve" src={storyThumbnail} alt='' />
                            </div>
                            <div className="w-100 fundrisers-route-border-color"></div>
                            <div className="card-body">
                                <div className="row gap-2">
                                    <div className="col-12">
                                        <div className="rounded-pill d-inline-flex justify-content-center align-items-center bd_tags">
                                            <span className="txt_wa">Pledge $55 or more</span>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <span className="fr_ch">Pellentesque habitant morbi <br />tristique senectus</span>
                                    </div>
                                    <div className="col-12">
                                        <span className="fr_cp">Lorem ipsum dolor sit amet, consectetur <br />adipiscing elit. Suspeisse nec molestie odio. Pellentesque suscipit luctus.</span>
                                    </div>
                                    <div className="col-12">
                                        <div>
                                            <span className="fr_lh">Included Items</span>
                                        </div>
                                        <ul className="mb-1">
                                            <li className="fr_li fundraisers-font-decoration " >Coloring lists (7)<br /></li>
                                            <li className="fr_li">14 set stickers (2)<br /></li>
                                            <li className="fr_li">3 postcards<br /></li>
                                        </ul>
                                    </div>
                                    <div className="col-12 d-flex justify-content-start align-items-center gap-1 mb-2">
                                        <span className="fr_lh">Estimated Delivery : </span>
                                        <span className="fr_li">December 2021</span>
                                    </div>
                                    <div className="col-12 d-flex justify-content-between align-items-center mb-4">
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                            <img src="assets/img/clips-imgs/clip-handshake.svg" alt='' />
                                            <div>
                                                <span className="fr_claimed">23&nbsp;</span>
                                                <span className="fr_tclaimed">Backers </span>
                                            </div>
                                        </div>
                                        <div className="h-100 fundraisers-empty-div"></div>
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                            <img src="assets/img/clips-imgs/clip-timer.svg" alt='' />
                                            <div>
                                                <span className="fr_claimed">15</span>
                                                <span className="fr_tclaimed">/200 claimed </span>
                                            </div>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <button className="rounded-pill w-100 fr_pbtn custm-pill-button-small" type="button">Get this Perk</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FundraisersStory;